import styled from "styled-components";

export const Container = styled.div`
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, #1e958c 0%, #0b4f6c 40%, #f5f7fb 100%);
`;

export const ContentArea = styled.div`
  width: 100%;
  max-width: 1400px;
  margin: 16px auto 24px;
  padding: 20px 24px 28px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.16);
  display: flex;
  flex-direction: column;
  gap: 18px;
  backdrop-filter: blur(8px);
`;

export const TitleArea = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const TitleSection = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
  }
`;

export const PageTitle = styled.span`
  text-align: center;
  font-weight: 700;
  font-size: 22px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #1e958c;
  margin: 0;
  white-space: nowrap;
  flex: 1;
  
  @media (max-width: 768px) {
    white-space: normal;
  }
`;

export const SelectionArea = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  gap: 16px;
  
  @media (max-width: 1200px) {
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;
export const SponteArea = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 10px 0;
  gap: 5px;
  width: 100%;
`;

export const WarningText = styled.p`
  color: #ab0505;
  text-align: center;
  width: 100%;
  font-size: 14px;
  line-height: 1.5;
  background-color: rgba(171, 5, 5, 0.05);
  padding: 12px 16px;
  border-radius: 8px;
  border-left: 4px solid #ab0505;
  margin: 10px 0;
`;

export const SponteButtons = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin: 5px 0;
  flex-wrap: wrap;
  
  button {
    min-width: 160px;
    padding: 10px 16px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    }
  }
`;

export const AnoLetivo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;

export const GradeItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
`;